import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import SeatSelected from "../../assets/images/seat_selected.svg"
import SeatTaken from "../../assets/images/seat_taken.svg"
import SeatAvailable from "../../assets/images/seat_available.svg"
import Volante from "../../assets/images/volante.png"
import ImageNotFound from '../../assets/images/not-found.png'
import axios from "axios"
import "./seat-mirror.css"

const SeatMirrorDisplay = () => {
  const { scheduleId } = useParams()
  const [seatData, setSeatData] = useState({})
  const [selectedSeats, setSelectedSeats] = useState([])
  const [occupiedSeats, setOccupiedSeats] = useState([])
  const [available, setAvailable] = useState(0)
  const [refreshInterval] = useState(2000) // Actualiza cada 2 segundos
  const [currentTime, setCurrentTime] = useState(new Date())
  const [lastUpdate, setLastUpdate] = useState(null)
  const [company, setCompany] = useState({})
  const [loadingLogo, setLoadingLogo] = useState(true)
  const [tripInfo, setTripInfo] = useState({
    base: "",
    origin: "",
    destination: "",
    date: "",
    time: "",
    totalPrice: 0
  })
  const [purchaseMessage, setPurchaseMessage] = useState(null)
  const [showPurchase, setShowPurchase] = useState(false)
  
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT
  const URLZFILES = process.env.REACT_APP_API_ZFILES

  // Bus layouts - MISMO QUE EN TICKETS.JS
  const busLayout11 = {
    row1: [0, 0, 0, 0, 1],
    row2: [2, 3, 0, 0, 0],
    row3: [4, 5, 0, 0, 0],
    row4: [7, 8, 0, 0, 6],
    row5: [10, 11, 0, 0, 9],
  }

  const busLayout18 = {
    row1: [0, 0, 0, 18, 1],
    row2: [2, 3, 0, 17, 0],
    row3: [4, 5, 0, 0, 6],
    row4: [7, 8, 0, 0, 9],
    row5: [15, 16, 0, 0, 14],
    row6: [10, 11, 0, 12, 13],
  }

  const busLayout20 = {
    row1: [0, 0, 0, 20, 1],
    row2: [2, 3, 0, 0, 0],
    row3: [4, 5, 0, 0, 6],
    row4: [7, 8, 0, 0, 9],
    row5: [15, 16, 0, 0, 17],
    row6: [18, 19, 0, 0, 14],
    row7: [10, 11, 0, 12, 13],
  }

  // Obtener información de la empresa
  const getInfoCompany = async () => {
    try {
      const response = await axios.get(ENDPOINT + 'get-company/' + 1)
      setCompany(response.data.data)
      setLoadingLogo(false)
    } catch (error) {
      console.log(error)
      setLoadingLogo(false)
    }
  }

  // Función para actualizar datos desde localStorage
  const updateSeatData = () => {
    const storedData = localStorage.getItem("mirrorSeatData")
    
    if (storedData) {
      try {
        const data = JSON.parse(storedData)
        
        setSeatData(data.seatData || {})
        setSelectedSeats(data.selectedSeats || [])
        setOccupiedSeats(data.occupiedSeats || [])
        
        // Asegurar que available sea un número
        let availableValue = data.available
        if (typeof availableValue === 'string') {
          availableValue = parseInt(availableValue, 10)
        }
        availableValue = Number(availableValue) || 0
        
        setAvailable(availableValue)
        
        // Actualizar timestamp de última actualización
        if (data.timestamp) {
          setLastUpdate(data.timestamp)
        }

        // Obtener información del viaje desde localStorage o mantener la existente
        const tripData = localStorage.getItem("mirrorTripInfo")
        if (tripData) {
          setTripInfo(JSON.parse(tripData))
        }
      } catch (error) {
        console.error("Error parsing seat data:", error)
      }
    }

    // Actualizar la hora en cada ciclo
    setCurrentTime(new Date())

    // Siempre checar si hay un mensaje de compra (aunque no exista mirrorSeatData)
    try {
      const purchaseData = localStorage.getItem("mirrorPurchase")
      if (purchaseData) {
        const p = JSON.parse(purchaseData)
        if (p && p.show) handlePurchaseMessage(p)
      }
    } catch (err) {
      console.warn("Error leyendo mirrorPurchase:", err)
    }
  }

  // Obtener datos de asientos del localStorage
  useEffect(() => {
    // Obtener información de la empresa
    getInfoCompany()

    // Llamar inmediatamente al cargar
    updateSeatData()

    // Manejar cambios en localStorage entre ventanas
    const handleStorageChange = (e) => {
      if (e.key === "mirrorSeatData" || e.key === "mirrorTripInfo") {
        updateSeatData()
      }
      if (e.key === "mirrorPurchase") {
        try {
          const payload = localStorage.getItem("mirrorPurchase")
          if (payload) {
            const p = JSON.parse(payload)
            if (p && p.show) handlePurchaseMessage(p)
          }
        } catch (err) {
          console.warn("Error procesando evento mirrorPurchase:", err)
        }
      }
    }

    // Manejar eventos personalizados de actualización forzada
    const handleForceUpdate = () => {
      updateSeatData()
    }

    // Crear listeners
    window.addEventListener("storage", handleStorageChange)
    window.addEventListener("forceMirrorUpdate", handleForceUpdate)

    // También actualizar en tiempo real
    const interval = setInterval(updateSeatData, refreshInterval)

    return () => {
      clearInterval(interval)
      window.removeEventListener("storage", handleStorageChange)
      window.removeEventListener("forceMirrorUpdate", handleForceUpdate)
    }
  }, [refreshInterval])

  // Función para forzar actualización manual
  const forceRefresh = () => {
    updateSeatData()
  }

  const handlePurchaseMessage = (p) => {
    if (!p || !p.show) return
    setPurchaseMessage(p.message || "Gracias por tu compra. ¡Que tengas buen viaje!")
    setShowPurchase(true)
    // Ocultar después de 5 segundos y limpiar la flag en localStorage
    setTimeout(() => {
      setShowPurchase(false)
      setPurchaseMessage(null)
      try {
        // Borrar la key para evitar re-disparos
        localStorage.removeItem("mirrorPurchase")
        window.dispatchEvent(new Event('forceMirrorUpdate'))
      } catch (err) {
        console.warn("Error limpiando mirrorPurchase:", err)
      }
    }, 5000)
  }

  const getSeatStatus = (seatNumber) => {
    if (!seatNumber || seatNumber === 0 || seatNumber === "") return "empty"
    if (selectedSeats.includes(seatNumber)) return "selected"
    if (occupiedSeats.includes(seatNumber)) return "taken"
    return "available"
  }

  // Buscar información de un asiento en seatData (acepta mapa o lista)
  const findSeatInfo = (seatNumber) => {
    if (!seatData) return null
    const direct = seatData[seatNumber] || seatData[String(seatNumber)]
    if (direct) return direct
    const found = Object.values(seatData).find((s) => Number(s?.seat) === Number(seatNumber))
    return found || null
  }

  const renderSeat = (seatNumber) => {
    const status = getSeatStatus(seatNumber)

    if (status === "empty") {
      return <div className="seat-space-mirror"></div>
    }

    // Obtener información del asiento (puede venir como objeto con keys o como valores)
    const getSeatInfo = () => {
      if (!seatData) return null
      // Intentar acceso directo por key (forms guarda por número)
      const direct = seatData[seatNumber] || seatData[String(seatNumber)]
      if (direct) return direct
      // Buscar en valores por si se envió un listado
      const found = Object.values(seatData).find((s) => Number(s?.seat) === Number(seatNumber))
      return found || null
    }

    const seatInfo = getSeatInfo()

    const seatImages = {
      selected: SeatSelected,
      taken: SeatTaken,
      available: SeatAvailable,
    }

    return (
      <div
        key={`seat-${seatNumber}`}
        className={`seat-button-mirror seat-${status}`}
        title={`Asiento ${seatNumber} - ${status}`}
      >
        <div
          style={{
            backgroundImage: `url(${seatImages[status]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: "100%",
            position: "relative",
          }}
        />
        <div 
          className="seat-number-mirror"
          style={{
            fontSize: "28px", 
            fontWeight: "bold",
            color: status === "selected" ? "white" : "black",
            textShadow: status === "selected" ? "1px 1px 2px rgba(0,0,0,0.8)" : "1px 1px 2px rgba(255,255,255,0.8)",
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 10,
          }}
        >
          {seatNumber}
        </div>

        {/* Nombre y precio ahora se muestran solo en la tarjeta de Información del Viaje */}
      </div>
    )
  }

  const legendItems = [
    {
      icon: SeatAvailable,
      status: "Disponible",
      colorClass: "seat-available",
    },
    { icon: SeatSelected, status: "Seleccionado", colorClass: "seat-selected" },
    { icon: SeatTaken, status: "Ocupado", colorClass: "seat-taken" },
  ]

  const totalSeats = available === 11 ? 11 : available === 18 ? 18 : available === 20 ? 20 : 0
  const availableCount = totalSeats - selectedSeats.length - occupiedSeats.length

  // Calcular precio total basado en los asientos seleccionados
  const calculateTotalPrice = () => {
    let total = 0
    Object.values(seatData).forEach(seat => {
      if (selectedSeats.includes(seat.seat)) {
        total += Number.parseFloat(seat.price || 0)
        total += Number.parseFloat(seat.petAmount || 0)
        total += Number.parseFloat(seat.extraLuggageAmount || 0)
      }
    })
    return total
  }

  const totalPrice = calculateTotalPrice()

  // Construir lista de nombres de pasajeros seleccionados para mostrar en la tarjeta
  const passengerNames = selectedSeats
    .map((seatNum) => {
      const info = findSeatInfo(seatNum)
      if (!info) return null
      const first = info.name || info.first_name || ""
      const last = info.last_name || ""
      const fullname = `${first} ${last}`.trim()
      return fullname || null
    })
    .filter(Boolean)
    .join(", ")

  return (
    <div className="seat-mirror-container">
      {/* Logo Grande en la parte superior */}
      <div className="seat-mirror-logo-container">
        {!loadingLogo && (
          <img 
            src={company.logo_main ? URLZFILES + company.logo_main : ImageNotFound} 
            alt="Logo" 
            className="seat-mirror-logo"
          />
        )}
      </div>

      <div className="seat-mirror-content">
        
        

        {/* Información del Viaje */}
        {(tripInfo.base || tripInfo.origin || totalPrice > 0) && (
          <div className="trip-info-card">
            {/* Overlay de agradecimiento al completar compra */}
            {showPurchase && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "rgba(0,0,0,0.45)",
                  zIndex: 9999,
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    padding: "24px 28px",
                    borderRadius: 12,
                    boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
                    textAlign: "center",
                    maxWidth: "720px",
                  }}
                >
                  <h2 style={{ margin: 0, color: "#0b5d2b", fontSize: 28 }}>{purchaseMessage}</h2>
                </div>
              </div>
            )}
            <div className="trip-info-header">
              <h5>Información del Viaje  -- -- -- 
                {currentTime.toLocaleTimeString("es-MX", {
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </h5>

              

            </div>
             
                
              
            <div className="trip-info-body">
              <div className="row g-3">
                {tripInfo.base && (
                  <div className="col-md-3">
                    <div className="trip-info-item">
                      <label>Base:</label>
                      <span>{tripInfo.base}</span>
                    </div>
                  </div>
                )}
                {tripInfo.origin && (
                  <div className="col-md-3">
                    <div className="trip-info-item">
                      <label>Origen:</label>
                      <span>{tripInfo.origin}</span>
                    </div>
                  </div>
                )}
                {tripInfo.destination && (
                  <div className="col-md-3">
                    <div className="trip-info-item">
                      <label>Destino:</label>
                      <span>{tripInfo.destination}</span>
                    </div>
                  </div>
                )}
                {totalPrice > 0 && (
                  <div className="col-md-3">
                    <div className="trip-info-item">
                      <label>Total:</label>
                      <span className="trip-price">${totalPrice} MXN</span>
                    </div>
                  </div>
                )}
              </div>
              {(tripInfo.date || tripInfo.time) && (
                <div className="row g-3 mt-2">
                  {tripInfo.date && (
                    <div className="col-md-6">
                      <div className="trip-info-item">
                        <label>Fecha:</label>
                        <span>{tripInfo.date}</span>
                      </div>
                    </div>
                  )}
                  {tripInfo.time && (
                    <div className="col-md-6">
                      <div className="trip-info-item">
                        <label>Horario:</label>
                        <span>{tripInfo.time}</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* Mostrar Nombres de pasajero(s) en un cuadro largo debajo de Fecha/Horario */}
              <div className="row mt-2">
                <div className="col-12">
                  <div
                    className="passenger-name-box"
                    style={{
                      background: "#f6fbff",
                      border: "1px solid #d9eefc",
                      padding: "12px 14px",
                      borderRadius: "6px",
                      minHeight: "56px",
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 700,
                      fontSize: "18px",
                      color: passengerNames ? "#0b5d2b" : "#6c757d",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      lineHeight: 1.2,
                    }}
                  >
                    {passengerNames ? passengerNames : "Nombre del pasajero..."}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Legend */}
        <div className="seat-mirror-legend">
          {legendItems.map((item, index) => (
            <div key={index} className="legend-item-mirror">
              <div
                style={{
                  backgroundImage: `url(${item.icon})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                className={`seat-icon-mirror ${item.colorClass}`}
              ></div>
              <span className="legend-text-mirror">{item.status}</span>
            </div>
          ))}
        </div>

        {/* Bus Layout */}
        <div className="seat-mirror-layout">
          <div className="driver-seat-mirror">
            <img
              src={Volante || "/placeholder.svg"}
              alt="volante"
              className="driver-wheel"
            />
          </div>

          {available === 11 ? (
            Object.values(busLayout11).map((row, index) => (
              <div key={index} className="row-mirror">
                <div className="seats-left">
                  {row.slice(0, 2).map((seat, idx) => (
                    <React.Fragment key={`left-${idx}`}>
                      {renderSeat(seat)}
                    </React.Fragment>
                  ))}
                </div>
                <div className="seats-center"></div>
                <div className="seats-right">
                  {row.slice(3).map((seat, idx) => (
                    <React.Fragment key={`right-${idx}`}>
                      {renderSeat(seat)}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))
          ) : available === 18 ? (
            Object.values(busLayout18).map((row, index) => (
              <div key={index} className="row-mirror">
                <div className="seats-left">
                  {row.slice(0, 2).map((seat, idx) => (
                    <React.Fragment key={`left-${idx}`}>
                      {renderSeat(seat)}
                    </React.Fragment>
                  ))}
                </div>
                <div className="seats-center"></div>
                <div className="seats-right">
                  {row.slice(3).map((seat, idx) => (
                    <React.Fragment key={`right-${idx}`}>
                      {renderSeat(seat)}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))
          ) : available === 20 ? (
            Object.values(busLayout20).map((row, index) => (
              <div key={index} className="row-mirror">
                <div className="seats-left">
                  {row.slice(0, 2).map((seat, idx) => (
                    <React.Fragment key={`left-${idx}`}>
                      {renderSeat(seat)}
                    </React.Fragment>
                  ))}
                </div>
                <div className="seats-center"></div>
                <div className="seats-right">
                  {row.slice(3).map((seat, idx) => (
                    <React.Fragment key={`right-${idx}`}>
                      {renderSeat(seat)}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className="no-layout">
              <p>Esperando datos del sistema de boletos...</p>
              <small style={{ color: "#999", display: "block", marginTop: "10px" }}>
                Available: {available} | Selected: {selectedSeats.length} | Occupied: {occupiedSeats.length}
              </small>
              <div className="mt-3">
                <button 
                  onClick={forceRefresh}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fas fa-sync-alt me-1"></i>
                  Actualizar
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Stats */}
        <div className="seat-mirror-stats">
          <div className="stat-item">
            <span className="stat-label">Disponibles:</span>
            <span className="stat-value available-count">{availableCount}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Seleccionados:</span>
            <span className="stat-value selected-count">{selectedSeats.length}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Ocupados:</span>
            <span className="stat-value taken-count">{occupiedSeats.length}</span>
          </div>
          {totalPrice > 0 && (
            <div className="stat-item">
              <span className="stat-label">Total:</span>
              <span className="stat-value price-total">${totalPrice}</span>
            </div>
          )}
        </div>
      </div>

      {/* Info Footer */}
      <div className="seat-mirror-footer">
        
        <p className="mirror-info-text">
          <i className="fas fa-info-circle me-2"></i>Unidad {
            available > 0 ? `de ${available} asientos` : 'Esperando datos...'
          }    {lastUpdate && (
            <small className="text-muted">
              Última actualización: {new Date(lastUpdate).toLocaleTimeString()}
            </small>
          )}
        </p>
      </div>
    </div>
  )
}

export default SeatMirrorDisplay